// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"266":"169e283a","386":"31672f65","662":"de07c61f","791":"397e0ec7","891":"1e608198","960":"c18f834a","981":"9cc42706"}[chunkId] + ".css";
};